/**
 * 共通編集素材の `AssetPort`（索引 Issue #498 の段階 6）。**`duelEditor/timeline/` の外**に置く。
 *
 * `duelEditor/timeline/` は何も知らない純粋な層なので、サーバー（`api/api.js`）を叩くものはここ。
 * 素材は共通編集素材（S3 の `editAssets/`）で、一覧は `GetEditAssets`・置くのは `UploadEditAsset` の
 * プリサイン URL へ PUT。
 *
 * **URL は署名付きで期限がある**ので、`AssetPort.url(name)` は値ではなく引くたびに表から返す
 * （取り直したら新しい URL に入れ替わる）。
 */
import { api } from '../api/api';
import { AssetPort } from '../duelEditor/timeline/ports/assets';

/** `GetEditAssets` を読んで `AssetPort` にする。`refresh()` で取り直す */
export function createEditAssetsPort() {
  const listeners = new Set();
  let table = {};
  let loading = false;
  let error = null;

  const port = AssetPort.create({
    url: (name) => table[name] ?? null,
    list: (prefix = '') => Object.keys(table).filter((k) => k.startsWith(prefix)).sort(),
    preload: (names = []) => names.map((n) => table[n]).filter(Boolean),
    subscribe: (fn) => { listeners.add(fn); return () => listeners.delete(fn); },
  });
  const emit = () => listeners.forEach((fn) => fn(port));

  async function refresh() {
    if (loading) return table;
    loading = true;
    try {
      const res = await api.project('GetEditAssets');
      table = Object.fromEntries((res?.assets ?? []).map((a) => [a.filename, a.download_url]));
      error = null;
    } catch (e) {
      error = String(e?.message ?? e);
    } finally {
      loading = false;
      emit();
    }
    return table;
  }

  /** 共通編集素材へ置く（プリサイン URL へ PUT）。置いたら一覧を取り直す */
  async function upload(filename, blob) {
    const res = await api.project('UploadEditAsset', { filename });
    const link = res?.upload_link;
    if (!link) throw new Error(res?.error ?? 'アップロード先が取れませんでした');
    const put = await fetch(link, { method: 'PUT', body: blob });
    if (!put.ok) throw new Error(`アップロードに失敗しました（${put.status}）`);
    await refresh();
    return filename;
  }

  return { ...port, refresh, upload, get error() { return error; }, get loading() { return loading; } };
}
